import AbstractField from "./AbstractField";

export default class ModeSelector extends AbstractField {
    setElement(element) {
        this.hide();
    }

    setDrawMode(type) {
        this.show();
        return this;
    }

    make() {
        this.field = this.p.createDiv();
        let label = this.p.createElement('h4', 'Shape')
            .parent(this.field)
            .class('input-label');
        this.radio = this.p.createRadio('mode-selector-radio')
            .parent(this.field)
            .class('mode-selector');

        this.parentElement ? this.field.parent(this.parentElement) : null;

        // let modeLabel = this.p.createElement('h4', 'Shape')
        //     .class('input-label')
        //     .parent(this.orderButtons);

        this.radio.option('rectangle');
        this.radio.option('polygon');
        this.radio.option('line');
        this.radio.option('ellipse')
        this.radio.selected('rectangle');
        this.radio.changed(() => this.getTool('shapes').setMode(this.radio.value()));

        let options = this.radio.elt.children;
        for (let i = 0; i < options.length; i++) {
            let option = options[i];
            option.classList.add('mode-selector-option');
            option.children[1].remove();
            let svg = SVG().addTo(option);
            svg.addClass('icon');
            if (i === 0) {
                if (!this.touch) {
                    option.setAttribute('data-tooltip', 'Rectangle (R)');
                }
                svg.use('square-line', '/icons/__remixicon.sprite.svg?v=491');
            } else if (i === 1) {
                if (!this.touch) {
                    option.setAttribute('data-tooltip', 'Free shape (F)');
                }
                svg.use('hexagon-line', '/icons/__remixicon.sprite.svg?v=491');
            } else if (i === 2) {
                if (!this.touch) {
                    option.setAttribute('data-tooltip', 'Line (Y)');
                }
                svg.use('pulse-line', '/icons/__remixicon.sprite.svg?v=491');
            } else {
                if (!this.touch) {
                    option.setAttribute('data-tooltip', 'Ellipse (O)');
                }
                svg.use('checkbox-blank-circle-line', '/icons/__remixicon.sprite.svg?v=491');

            }
        }
        this.initialized = true;
        return this;
    }

    selected(value) {
        this.radio.selected(value);
    }
}
